export default __webpack_public_path__ + "static/media/china.ad58b6a0.png";